import { render } from "./TimetableIndex.vue?vue&type=template&id=509dc10f&scoped=true&ts=true"
import script from "./TimetableIndex.vue?vue&type=script&lang=ts"
export * from "./TimetableIndex.vue?vue&type=script&lang=ts"

import "./TimetableIndex.vue?vue&type=style&index=0&id=509dc10f&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509dc10f"]])

export default __exports__